var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      all: "",
      multiple: true
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.checkPage();
            }
          }
        }, [_vm._v("查询")])];
      },
      proxy: true
    }])
  })], 1), _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      height: "650",
      border: "",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    },
    on: {
      custom: _vm.onCustom
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "config_id",
      width: "100",
      label: "序号",
      sortable: ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      width: "200",
      label: "充值区间"
    }
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "人数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.pay_role !== undefined && scope.row.pay_role_prop !== undefined ? _c("span", {
          staticClass: "spanPay"
        }, [_c("div", {
          staticClass: "payClass"
        }, [_vm._v(_vm._s(scope.row.pay_role))]), _c("div", {
          staticClass: "payRoleClass"
        }, [_vm._v("(" + _vm._s(scope.row.pay_role_prop) + "%)")])]) : _c("span", [_vm._v(" - ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "总充值金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.pay_count !== undefined && scope.row.pay_count_prop !== undefined ? _c("span", {
          staticClass: "spanCount"
        }, [_c("div", {
          staticClass: "countClass",
          staticStyle: {
            color: "blue",
            cursor: "pointer"
          },
          on: {
            click: function click($event) {
              return _vm.showDialog(scope.row.config_id);
            }
          }
        }, [_vm._v(_vm._s(scope.row.pay_count))]), _c("div", {
          staticClass: "countPropClass"
        }, [_vm._v("( " + _vm._s(scope.row.pay_count_prop) + " % )")])]) : _c("span", [_vm._v(" - ")])];
      }
    }])
  })], 1)]], 2), _c("div", [_vm.dialog ? _c("el-dialog", {
    attrs: {
      title: "",
      visible: _vm.dialog,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialog = $event;
      }
    }
  }, [_c("el-table", {
    attrs: {
      data: _vm.goodsData,
      "show-summary": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "goods_id",
      label: "充值项",
      width: "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.goodsList[scope.row.goods_id]) + "(" + _vm._s(scope.row.goods_id) + ") ")];
      }
    }], null, false, 1608585669)
  }), _c("el-table-column", {
    attrs: {
      sortable: "",
      prop: "finish_num",
      label: "付费次数"
    }
  }), _c("el-table-column", {
    attrs: {
      sortable: "",
      prop: "count",
      label: "总付费金额"
    }
  })], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };